import React, {useContext} from 'react';
import * as R from 'ramda';
import styles from '@/views/Layout/internal/InternalNavBar/index.module.css';
import {
  MainMenuFor,
  MenuFor,
  LabelFor,
  DropdownMainMenu,
} from '@/views/Layout/internal/InternalNavBar/detectMenu';
import {SystemConfigCtx} from '@/contexts';

const BatchNavContent = () => (
  <div className={styles.megamenu} style={{width: '510px'}}>
    <div className={styles.megamenu_column}>
      <LabelFor name='bulkFollowup' label='Bulk Followup' />
      <ul>
        <BatchMenuFor name='followupBatch' />
        <BatchMenuFor name='followupBatchHistory' />
      </ul>
      <br />
      <LabelFor
        name='bulkFollowupCompletion'
        label='Bulk Followup Completion'
      />
      <ul>
        <BatchMenuFor name='completionBatch' />
        <BatchMenuFor name='completionBatchHistory' />
      </ul>
      <br />
      <LabelFor name='bulkHoldEmail' label='Bulk Hold Email' />
      <ul>
        <BatchMenuFor name='batchEdit' />
      </ul>
    </div>
    <div className={styles.megamenu_column}>
      <LabelFor name='letterTemplate' label='Letter Template' />
      <LetterTemplateNavContent />
    </div>
  </div>
);

const LetterTemplateNavContent = () => {
  const {siteCode} = useContext(SystemConfigCtx);
  if (siteCode === 'afs') {
    return (
      <ul>
        <BatchMenuFor name='advisoryRenewalLetterAWM' />
        <BatchMenuFor name='advisoryRenewalLetterBMW' />
        <BatchMenuFor name='advisoryWelcomeLetter' />
        <BatchMenuFor name='forgetpasswordLetter' />
        <BatchMenuFor name='policyLetter' />
        <BatchMenuFor name='policyAssignmentLetter' />
        <BatchMenuFor name='professionalInvestorRenewalLetter' />
        <BatchMenuFor name='professionalInvestorCancellationLetter' />
        <BatchMenuFor name='salesAssignmentLetter' />
        <BatchMenuFor name='successionTrustLetter' />
        <BatchMenuFor name='tRAdvisoryWelcomeLetter' />
        <BatchMenuFor name='tRAssignmentLetter' />
        <BatchMenuFor name='welcomeLetter' />
      </ul>
    );
  }

  return (
    <ul>
      <BatchMenuFor name='welcomeLetter' />
      <BatchMenuFor name='policyLetter' />
      <BatchMenuFor name='advisoryWelcomeLetter' />
      <BatchMenuFor name='advisoryRenewalLetter' />
      <BatchMenuFor name='salesAssignmentLetter' />
      <BatchMenuFor name='policyAssignmentLetter' />
      <BatchMenuFor name='successionTrustLetter' />
      <BatchMenuFor name='professionalInvestorRenewalLetter' />
      <BatchMenuFor name='privateBankAdvisoryRenewalLetter' />
      <BatchMenuFor name='forgetpasswordLetter' />
      <BatchMenuFor name='tRAdvisoryWelcomeLetter' />
      <BatchMenuFor name='tRAssignmentLetter' />
    </ul>
  );
};

const BatchMenuFor = ({name}) => {
  const labelName = [
    // batch
    {name: 'followupBatch', label: 'Followup Batch'},
    {name: 'followupBatchHistory', label: 'Followup Batch History'},
    {name: 'completionBatch', label: 'Completion Batch'},
    {name: 'completionBatchHistory', label: 'Completion Batch History'},
    {name: 'batchEdit', label: 'Batch Edit'},

    // letter
    {name: 'advisoryRenewalLetterAWM', label: 'Advisory Renewal Letter (AWM)'},
    {name: 'advisoryRenewalLetterBMW', label: 'Advisory Renewal Letter (BMW)'},
    {name: 'welcomeLetter', label: 'Welcome Letter'},
    {name: 'policyLetter', label: 'Policy Letter'},
    {name: 'advisoryWelcomeLetter', label: 'Advisory Welcome Letter'},
    {name: 'advisoryRenewalLetter', label: 'Advisory Renewal Letter'},
    {name: 'salesAssignmentLetter', label: 'Sales Assignment Letter'},
    {name: 'policyAssignmentLetter', label: 'Policy Assignment Letter'},
    {name: 'successionTrustLetter', label: 'Succession Trust Letter'},
    {
      name: 'professionalInvestorRenewalLetter',
      label: 'Professional Investor Renewal Letter',
    },
    {
      name: 'privateBankAdvisoryRenewalLetter',
      label: 'Private Bank Advisory Renewal Letter',
    },
    {name: 'forgetpasswordLetter', label: 'Forget password Letter'},
    {name: 'tRAdvisoryWelcomeLetter', label: 'TR Advisory Welcome Letter'},
    {name: 'tRAssignmentLetter', label: 'TR Assignment Letter'},
    {
      name: 'professionalInvestorRenewalLetter',
      label: 'Professional Investor Renewal Letter',
    },
    {
      name: 'professionalInvestorCancellationLetter',
      label: 'Professional Investor Cancellation Letter',
    },
  ];

  const {label} = R.find(R.propEq('name', name))(labelName);

  return (
    <li>
      <MenuFor name={name} type='subMenu' label={label} />
    </li>
  );
};

const BatchNav = () => (
  <MainMenuFor name='batch'>
    <DropdownMainMenu name='batch' label='Batch'>
      <BatchNavContent />
    </DropdownMainMenu>
  </MainMenuFor>
);

export default BatchNav;
